import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import styles from './best-sellers-rank-badge.scss'

const BestSellersRankBadge = ({ isShowBestSellerText, best_seller_rank }) => {
  const badgeText = isShowBestSellerText
    ? `#${best_seller_rank} Best Seller`
    : best_seller_rank

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <div className="best-sellers-rank-badge">
        <div className="best-sellers-rank-badge__wrapper">
          <span className={clsx(Typo.body2)}>{badgeText}</span>
        </div>
      </div>
    </React.Fragment>
  )
}

BestSellersRankBadge.defaultProps = {
  isShowBestSellerText: true,
}

BestSellersRankBadge.propTypes = {
  isShowBestSellerText: PropTypes.bool,
  best_seller_rank: PropTypes.number.isRequired,
}

export default withI18next()(BestSellersRankBadge)
